// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1IxmO","file":"styles_file__38TBA"};